<template>
  <div class="my-page">
    <div class="page-header disFlex fc Flex-between">
      <img src="https://j.weizan.cn/youxiang/header-bg.png" class="bg-img" />
      <div class="header-detail disFlex fc">
        <div class="header-item disFlex vertical fvc">
          <div class="item-title">总金额</div>
          <div class="item-price disFlex">
            <div>{{total}}</div>
            <div class="item-unit">元</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="header-item disFlex vertical fvc">
          <div class="item-title">已到账金额</div>
          <div class="item-price disFlex">
            <div>{{withdraw}}</div>
            <div class="item-unit">元</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="header-item disFlex vertical fvc">
          <div class="item-title disFlex fc">
            剩余金额
            <div class="cash-btn" @click="goWithDraw">去提现</div>
          </div>
          <div class="item-price disFlex">
            <div>{{avaliable}}</div>
            <div class="item-unit">元</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="body-header disFlex fc Flex-between">
        <div class="disFlex fc">
          <div
            class="head-item disFlex vertical fvc"
            :class="{'active-item':currentType===1}"
            @click="changeType(1)"
          >
            <div>自动到账明细</div>
            <div class="line" :class="{'active-line':currentType===1}"></div>
          </div>
          <div
            class="head-item disFlex vertical fvc"
            :class="{'active-item':currentType===2}"
            @click="changeType(2)"
          >
            <div>提现到账明细</div>
            <div class="line" :class="{'active-line':currentType===2}"></div>
          </div>
        </div>
        <div class="ask" @click="viewRlue">?</div>
      </div>
      <div class="body-body">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
          <div class="data-item disFlex Flex-between" v-for="item in withdrawList" :key="item.id">
            <div class="data-left">
              <div class="title">到账金额</div>
              <div class="price disFlex">
                {{item.amount}}
                <div class="unit">元</div>
              </div>
            </div>
            <div class="data-right">
              <div
                class="status"
              >{{currentType===2?(item.status==='pass'?'审核通过':item.status==='under_review'?'审核中':item.status==='no_pass'?'审核不通过':item.status==='failure'?'提现失败':''):''}}</div>
              <div class="date">{{item.createTime}}</div>
            </div>
          </div>
        </van-list>
      </div>

      <div class="f fvc v">
        <div class="back-btn" @click="backHome">返回首页</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentType: 1, //1 自动到账 2 提现到账
      withdrawRule: "",
      currentPage: 1,
      withdrawList: [],
      finished: false,
      total: 0,
      withdraw: 0,
      avaliable: 0,
      loading: false,
    };
  },
  created() {
    this.getUserAccount();
    this.getWithdrawRule();
    this.getUserAutoArrived();
  },
  methods: {
    getUserAccount() {
      this.$http.post("/v1/finance/account/user_account").then((res) => {
        this.avaliable = res.data.avaliable;
        this.total = res.data.total;
        this.withdraw = res.data.withdraw;
      });
    },
    // 自动到账
    getUserAutoArrived() {
      this.loading = true;
      this.$http
        .post("/v1/finance/withdraw/user_auto_arrived", {
          page: this.currentPage,
          size: 10,
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 10200) {
            this.finished = true;
          } else {
            this.withdrawList = this.withdrawList.concat(res.data.list);
          }
        });
    },
    // 提现到账
    userWithdrawList() {
      this.loading = true;

      this.$http
        .post("/v1/finance/withdraw/user_withdraw_list", {
          page: this.currentPage,
          size: 10,
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 10200) {
            this.finished = true;
          } else {
            this.withdrawList = this.withdrawList.concat(res.data.list);
          }
        });
    },
    loadMore() {
      if (!this.finished) {
        this.currentPage++;
        this.currentType == 1
          ? this.getUserAutoArrived()
          : this.userWithdrawList();
      }
    },
    getWithdrawRule() {
      this.$http.post("/v1/finance/config/query_rule").then((res) => {
        this.withdrawRule = res.data;
      });
    },
    changeType(e) {
      this.finished = false;
      this.currentPage = 1;
      this.withdrawList = [];
      this.currentType = e;
      this.currentType == 1
        ? this.getUserAutoArrived()
        : this.userWithdrawList();
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    goWithDraw() {
      this.$router.push({
        path: "/my/withdraw",
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    viewRlue() {
      const that = this;
      that.$dialog({
        title: "提现规则",
        message: that.withdrawRule,
        closeOnClickOverlay: true,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.my-page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: #003078;
  .page-header {
    position: relative;
    height: 98px;
    .bg-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 151px;
      height: 190px;
    }
    .header-detail {
      z-index: 1;
      .header-item {
        width: 125px;
        .item-title {
          margin-bottom: 10px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          .cash-btn {
            margin-left: 5px;
            width: 40px;
            height: 15px;
            line-height: 15px;
            text-align: center;
            background: rgba(255, 209, 143, 1);
            border-radius: 3px;
            font-size: 10px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(0, 48, 120, 1);
          }
        }
        .item-price {
          font-size: 20px;
          font-family: DIN;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          .item-unit {
            font-size: 12px;
            position: relative;
            top: 7px;
          }
        }
      }
      .line {
        width: 1px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
      }
    }
  }
  .page-body {
    min-height: calc(100vh - 98px);
    background: rgba(255, 255, 255, 1);
    border-radius: 15px 15px 0px 0px;
    padding: 12px 16px 0;
    .body-header {
      border-bottom: 1px solid #f5f6f7;
      .head-item {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #696969;

        margin-right: 44px;
        .line {
          width: 20px;
          height: 2px;
          background: transparent;
          margin-top: 13px;
        }
        .active-line {
          background: rgba(0, 48, 120, 1) !important;
        }
      }
      .active-item {
        color: rgba(0, 48, 120, 1) !important;
      }
      .ask {
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(203, 151, 76, 1);
        line-height: 16px;
        text-align: center;
        width: 16px;
        height: 16px;
        background: rgba(255, 209, 143, 1);
        opacity: 0.5;
        border-radius: 8px;
        position: relative;
        top: -8px;
      }
    }
    .body-body {
      height: 64vh;
      overflow-y: scroll;
      .data-item {
        padding: 20px 0;
        border-bottom: 1px solid #f5f6f7;
        .data-left {
          .title {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(53, 53, 53, 1);
          }
          .price {
            margin-top: 12px;
            font-size: 20px;
            font-family: DIN;
            font-weight: bold;
            color: rgba(203, 151, 76, 1);
            .unit {
              font-size: 12px;
              font-weight: normal;
              position: relative;
              top: 7px;
            }
          }
        }
        .data-right {
          padding-top: 10px;
          .status {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(244, 0, 0, 1);
            text-align: right;
            height: 12px;
          }
          .date {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(116, 116, 116, 1);
            margin-top: 9px;
          }
        }
      }
    }
    .back-btn {
      width: 315px;
      height: 44px;
      border: 1px solid rgba(0, 48, 120, 1);
      border-radius: 22px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
      line-height: 44px;
      text-align: center;
      position: fixed;
      bottom: 26px;
      background: #fff;
    }
  }
}
</style>